/**
 *  Created by piotr@revisual.io on 18/08/2025
 */
import ModalTemplate from "../../modals/ModalTemplate";
import PlanComparisonTable from "./PlanComparisonTable";

/**
 *
 * @param {Object} selectedPlan
 * @param {Object} selectedPrice
 * @param {function} onCancel
 * @param {function} onSubmit
 * @returns {JSX.Element}
 * @constructor
 */

export const PlanDowngradeModal = ({
  selectedPlan,
  selectedPrice,
  onCancel,
  onSubmit,
}) => {
  return (
    <ModalTemplate
      id={"billingDetailsModal"}
      header={"Plan Downgrade Details"}
      size={"lg"}
      onClose={onCancel}
    >
      <PlanComparisonTable
        newPlan={selectedPlan}
        newPrice={selectedPrice}
        onCancel={onCancel}
        onSubmit={onSubmit}
      />
    </ModalTemplate>
  );
};

export default PlanDowngradeModal;
